module.exports = __webpack_public_path__ + "img/home-5.580f7ff6.png";